<div class="page-container box-container-users">
    <audit-breadcrumb *ngIf="breadcrumbs" [breadcrumbs$]="breadcrumbs"
        (handleClick)="navigateLast($event)"></audit-breadcrumb>

    <div class="d-flex fd-row justify-space-between section-title-user pb-md-24 mt-16">
        <div
            class="text-color-secondary-1 d-flex fd-row align-items-center letter-spacing-1 text-size-32 text-md-size-24 text-weight-600">
            <sit-icon class="col-sm d-flex d-md-none" [icon]="Icon.user_y" [sizeClass]="'icon-size-40'"
                alt="icono de usuario"></sit-icon>
            <sit-icon (click)="navigateToVisor()" class="d-md-flex d-none" [icon]="Icon.previous_page_y"
                alt="Icono boton atrás" [sizeClass]="'icon-size-32'"></sit-icon>
            <span class="ml-8">{{ 'Nombre Persona' }}</span>
        </div>
    </div>
    <hr class="mb-1 line-separator d-md-none" />

    <ng-container *ngIf="properties">
        <div class="card-info-main mb-16">
            <div class="card-body-main">
                <ng-container *ngFor="let header of properties.headersMain">
                    <div class="card-info-item">
                        <p class="card-info-title">
                            {{ properties.dataMain[header.key] }}
                        </p>
                        <p class="card-info-value">
                            {{ header.label }}
                        </p>
                    </div>
                </ng-container>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="properties">
        <div class="card-info">
            <h4 class="card-title">Registro</h4>
            <div class="card-body">
                <ng-container *ngFor="let header of properties.headersBody">
                    <div class="card-info-item" *ngIf="properties.dataBody[header.key]">
                        <p class="card-info-title">
                            {{ header.label }}
                        </p>
                        <p class="card-info-value">
                            {{ properties.dataBody[header.key] }}
                        </p>
                    </div>
                </ng-container>
            </div>
        </div>
    </ng-container>
</div>